<template>
  <div class="transferBox">
    <!-- 筛选模块 -->
    <FilterBar ref="filterBar" :show-status-option="false"  :show-user-id-option="false" @search="onSearch" @export="onExport"></FilterBar>
    <el-row class="btn_row" type="flex" justify="space-between">
      <el-button type="primary" @click="importFile">导入名单</el-button>
      <div class="query-right">
        <ExportProgress ref="downloadDialog"></ExportProgress>
        <ExportExcel
          v-show="false"
          config-name="ExternalContact"
          :excel-data="excelData"
          @emit="handleExportExcel"
        ></ExportExcel>
      </div>
    </el-row>
    <!-- table -->
    <div class="listContent">
      <el-table
        v-loading="loading"
        ref="transTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <template slot="empty">
          <NoData></NoData>
        </template>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="create_time" label="操作时间" width="180">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.create_time
                  ? dateFormat(new Date(scope.row.create_time), 'YYYY-MM-dd HH:mm:SS')
                  : '--'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="create_by" label="操作人"></el-table-column>
        <el-table-column prop="total" label="总条数"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span>{{ statusList.find((item) => item.value == scope.row.status).label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="success_time" label="完成时间" width="180">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.success_time
                  ? dateFormat(new Date(scope.row.success_time), 'YYYY-MM-dd HH:mm:SS')
                  : '--'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="success" label="成功数"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="pagination"
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="size"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
    <!-- importFile Dialog -->
    <import-file
      ref="importFile"
      :show-import-file="showImportFile"
      @close="importFileClose"
    ></import-file>
  </div>
</template>

<script>
import NoData from '@/components/no-data';
import { dateFormat } from '@/utils/time';
import FilterBar from './filterBar.vue';
import {statusList} from '../constrants'
import ImportFile from "@/views/externalContactsTransfer/components/importFile";
import {getExternalTransferList} from '@/api/transferContacts';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';

export default {
  name: 'Transfer',
  components: {
    ImportFile,
    NoData,
    FilterBar,
    ExportExcel,
    ExportProgress,
  },
  data() {
    return {
      statusList,
      dateFormat,
      loading: false,
      tableData: [],
      currentPage: 1,
      size: 10,
      total: 0,
      showImportFile: false,
      excelData: [],
    };
  },
  created() {
    this.size = this.g_pageSizeDefault;
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getPayload(page,pageSize){
      return {
        page: page,
        page_size: pageSize,
        name: this.$refs.filterBar.form.operator,
        start_time: this.$refs.filterBar.date[0] != null ? `${this.$refs.filterBar.date[0]}  00:00:00` : "",
        end_time: this.$refs.filterBar.date[1] != null ? `${this.$refs.filterBar.date[1]}  23:59:59` : "",
      };
    },
    async handleExportExcel() {
      console.log("handleExportExcel")
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(30);

      const res = await getExternalTransferList(this.getPayload(1,1))

      if (res.total > 50000) {
        this.$message.warning(`最大支持导出5万条数据，当前数据${res.total}条，请重新筛选`);
        this.$refs.downloadDialog.abortProgress();
      } else {
        const res = await getExternalTransferList(this.getPayload(1,50000))
        if (res.err_code === 0) {
          this.excelData = res.list.map(item=>{
            let statusMsg = statusList[0].label;
            statusList.forEach(statusItem=>{
              if(statusItem.value == item.status){
                statusMsg = statusItem.label;
              }
            })
            item.status = statusMsg;
            return item;
          })
          this.$refs.downloadDialog.finishProgress(500);
        }
      }
      this.loading = false;
      return;
    },
    async getTableData() {
      this.loading = true;
      await this.$nextTick();
      const response = await getExternalTransferList(this.getPayload(
         this.currentPage, this.size || this.g_pageSizeDefault,
      ))
      if (response.err_code === 0) {
        this.total = response.total;
        this.tableData = response.list;
      }
      this.loading = false;
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    onExport(){
      this.handleExportExcel()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTableData();
    },
    openDetail(row) {
      const { id } = row
      this.$emit('swicthTab', {id});
    },
    importFile() {
      this.showImportFile = true;
    },
    importFileClose() {
      this.$refs.importFile.resetImportStatus();
      this.showImportFile = false;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.transferBox {
  .btn_row {
    padding: 16px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
  .pagination {
    text-align: right;
    margin: 10px 0;
  }
}
</style>
